import { SelectProps, Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"

type Props = {
  filtersValue: filtersValidationType
  setFiltersValue: Dispatch<SetStateAction<filtersValidationType>>
} & SelectProps

export const ProductDuplicateProductionSiteFilter = ({
  setFiltersValue,
  filtersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")

  return (
    <Select
      data={[
        { value: "all", label: t("lists.placeholders.all") },
        { value: "redundant", label: t("lists.placeholders.redundant") },
      ]}
      w={150}
      size="xs"
      clearable
      searchable
      onChange={(value) =>
        setFiltersValue({
          ...filtersValue,
          duplicateSites:
            value === "redundant" || value === "all" || value === undefined
              ? value
              : undefined,
        })
      }
      placeholder={t("lists.placeholders.duplicateSites")}
      value={filtersValue.duplicateSites}
      {...props}
    />
  )
}
